import React, { useEffect, useState } from "react";
import { doc, updateDoc, increment } from "firebase/firestore";
import { db, auth } from "../firebase";
import "./reactions.css";

const EMOJIS = [
  ["like", "👍"],
  ["celebrate", "🎉"],
  ["insightful", "💡"],
  ["support", "🤝"],
  ["funny", "😂"],
];

function Reactions({ postId, post }) {
  const uid = auth.currentUser?.uid;

  const [localReactions, setLocalReactions] = useState(
    post?.reactions || {}
  );
  const [userReaction, setUserReaction] = useState(
    post?.userReactions?.[uid] || null
  );

  // Sync from Firestore ONLY when post changes
  useEffect(() => {
    if (!post) return;

    setLocalReactions(post.reactions || {});
    setUserReaction(post.userReactions?.[uid] || null);
  }, [post, uid]);

  const handleReact = async (type) => {
    if (!uid) return;

    const ref = doc(db, "community_posts", postId);

    // CASE 1: Remove reaction
    if (userReaction === type) {
      setUserReaction(null);
      setLocalReactions(prev => ({
        ...prev,
        [type]: Math.max((prev[type] || 1) - 1, 0),
      }));

      await updateDoc(ref, {
        [`reactions.${type}`]: increment(-1),
        [`userReactions.${uid}`]: null,
      });

      return;
    }

    // CASE 2: Switch reaction
    if (userReaction && userReaction !== type) {
      setLocalReactions(prev => ({
        ...prev,
        [userReaction]: Math.max((prev[userReaction] || 1) - 1, 0),
        [type]: (prev[type] || 0) + 1,
      }));

      await updateDoc(ref, {
        [`reactions.${userReaction}`]: increment(-1),
        [`reactions.${type}`]: increment(1),
        [`userReactions.${uid}`]: type,
      });

      setUserReaction(type);
      return;
    }

    // CASE 3: New reaction
    setUserReaction(type);
    setLocalReactions(prev => ({
      ...prev,
      [type]: (prev[type] || 0) + 1,
    }));

    await updateDoc(ref, {
      [`reactions.${type}`]: increment(1),
      [`userReactions.${uid}`]: type,
    });
  };

  return (
    <div className="reaction-bar">
      {EMOJIS.map(([type, emoji]) => (
        <span
          key={type}
          className={`reaction-btn ${
            userReaction === type ? "reacted" : ""
          }`}
          onClick={() => handleReact(type)}
        >
          {emoji} {localReactions[type] || 0}
        </span>
      ))}
    </div>
  );
}

export default Reactions;
